import { fromPromise } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { BACKEND_ERROR } from "../../constants";
import { clearTokens, saveTokens } from "../../helpers/tokens";
import { refreshAccessToken } from "./authLink";
import { getGraphQLClientInstance } from "./instance";

let isRefreshing = false;
// biome-ignore lint/suspicious/noExplicitAny: skip
let pendingRequests: (() => any)[] = [];

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback());
  pendingRequests = [];
};

export const getErrorLink = ({ addSentryBreadcrumb, captureSentryException, AppStorage }: ToDo) =>
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: skip
  onError(({ graphQLErrors, networkError, operation, forward, response }) => {
    addSentryBreadcrumb(`GraphQL network error: ${operation.operationName} operation`, {
      data: { error: JSON.stringify(networkError), response: JSON.stringify(response) },
    });

    if (graphQLErrors && graphQLErrors?.length > 0) {
      for (const { message, locations, path, extensions } of graphQLErrors) {
        if (extensions?.code === BACKEND_ERROR.Unauthenticated) {
          let forward$: ToDo;

          if (isRefreshing) {
            // Will only emit once the Promise is resolved
            forward$ = fromPromise(
              new Promise((resolve) => {
                pendingRequests.push(() => resolve(""));
              }),
            );
          } else {
            isRefreshing = true;
            forward$ = fromPromise(
              refreshAccessToken({ client: getGraphQLClientInstance(), AppStorage })
                .then((accessToken) => {
                  if (accessToken) {
                    saveTokens({ accessToken, AppStorage });
                    resolvePendingRequests();
                  }
                  return accessToken;
                })
                .catch(() => {
                  pendingRequests = [];
                  clearTokens({ AppStorage });
                  return;
                })
                .finally(() => {
                  isRefreshing = false;
                }),
            ).filter((value) => Boolean(value));
          }

          return forward$.flatMap(() => forward(operation));
        }

        addSentryBreadcrumb(`[GraphQL error]: ${message}`, {
          level: "error",
          category: "apiRequest",
          data: { locations, path, extensions },
        });
      }

      addSentryBreadcrumb(`[GraphQL Operation]: ${operation.operationName}`, {
        level: "error",
        category: "apiRequest",
        data: operation.variables,
      });

      captureSentryException(
        `[GraphQL error]: ${graphQLErrors?.[0]?.message ?? "Request returned an error"}`,
      );
    }

    if (networkError) {
      addSentryBreadcrumb(`[Network error] ${networkError.name}: ${networkError.message}`, {
        level: "error",
        category: "network",
      });
      captureSentryException(
        `[Network error] ${networkError.name}: ${JSON.stringify(networkError)}`,
      );
    }

    return;
  });
